// Module
var code = "<react-component name=\"TasksList\"></react-component>\n";
// Exports
module.exports = code;